import React from "react";
import { useLocation, BrowserRouter, Routes, Route } from "react-router-dom";
import { createAuthContext } from "./AuthContext";
import { Login } from "../Login/Login";
import { CallbackRoute } from "../CallbackRoute";
import { DataCollection } from "../../DataCollection/DataCollection";
import { UnauthorisedUser } from "../../UnauthorisedUser/UnauthorisedUser";
import { ROUTER_PATHS } from "../../../constants/constants";

/** Component to handle callback route with location data */
const CallbackRouteWrapper = ({ callbackURL, formatData }) => {
  const location = useLocation();
  return (
    <CallbackRoute
      callbackURL={callbackURL}
      formatData={formatData}
      search={location.search}
    />
  );
};

/** AuthRouter is the React router to be used when you wish to add OAuth to your app. */
export const AuthRouter = ({
  initialAuthInfo,
  loginPath,
  loginURL,
  callbackPath,
  callbackURL,
  formatData,
  children,
}) => {
  const AuthContext = createAuthContext(initialAuthInfo);

  return (
    <AuthContext.Provider value={initialAuthInfo}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DataCollection />} />
          <Route path={`/${ROUTER_PATHS.UNAUTHORISED_USER}`} element={<UnauthorisedUser />} />
          <Route path={loginPath} element={<Login loginURL={loginURL} />} />
          <Route
            path={callbackPath}
            element={
              <CallbackRouteWrapper
                callbackURL={callbackURL}
                formatData={formatData}
              />
            }
          />
          {children}
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
};
